import React from 'react';
import { SpinLoadingWrapper } from './spinLoadingStyle';
import images from 'assets/images-base';
import { useTranslation } from 'react-i18next';

const SpinLoading = ({ small }: { small?: boolean }) => {
  const { t } = useTranslation();
  return (
    <SpinLoadingWrapper small={small}>
      <img src={images.search.spinner} alt={t('search.loading')} />
    </SpinLoadingWrapper>
  );
};

export default SpinLoading;
